export const colors = {
  surfaces: {
    canvas: "bg-background",
    card: "bg-card border border-border",
    elevated: "bg-popover border border-border/60",
    subtle: "bg-muted",
    skeleton: "bg-muted",
  },
  text: {
    primary: "text-foreground",
    subtle: "text-muted-foreground",
    inverse: "text-background",
  },
  accents: {
    primary: {
      background: "bg-primary",
      foreground: "text-primary-foreground",
      border: "border-transparent",
      hover: "hover:bg-primary/80",
      shadow: "shadow",
      icon: "text-primary-foreground",
    },
    secondary: {
      background: "bg-secondary",
      foreground: "text-secondary-foreground",
      border: "border-transparent",
      hover: "hover:bg-secondary/80",
      shadow: "shadow-sm",
      icon: "text-secondary-foreground",
    },
    destructive: {
      background: "bg-destructive",
      foreground: "text-destructive-foreground",
      border: "border-transparent",
      hover: "hover:bg-destructive/80",
      shadow: "shadow-sm",
      icon: "text-destructive-foreground",
    },
    muted: {
      background: "bg-muted",
      foreground: "text-muted-foreground",
      border: "border-border",
      hover: "hover:bg-muted/80",
      shadow: "shadow-none",
      icon: "text-muted-foreground",
    },
  },
  status: {
    neutral: {
      surface: "bg-muted",
      border: "ring-1 ring-border",
      foreground: "text-foreground/80",
      hover: "hover:bg-muted/80",
      icon: "text-muted-foreground",
    },
    success: {
      surface: "bg-emerald-500/15",
      border: "ring-1 ring-emerald-600/30 dark:ring-emerald-500/40",
      foreground: "text-emerald-700 dark:text-emerald-200",
      hover: "hover:bg-emerald-500/20 dark:hover:bg-emerald-500/25",
      icon: "text-emerald-600 dark:text-emerald-300",
    },
    warning: {
      surface: "bg-amber-500/15",
      border: "ring-1 ring-amber-600/30 dark:ring-amber-500/40",
      foreground: "text-amber-700 dark:text-amber-200",
      hover: "hover:bg-amber-500/20 dark:hover:bg-amber-500/25",
      icon: "text-amber-600 dark:text-amber-300",
    },
    danger: {
      surface: "bg-destructive/15",
      border: "ring-1 ring-red-600/30 dark:ring-red-500/40",
      foreground: "text-destructive dark:text-red-200",
      hover: "hover:bg-destructive/20 dark:hover:bg-destructive/25",
      icon: "text-destructive dark:text-red-300",
    },
    info: {
      surface: "bg-primary/15",
      border: "ring-1 ring-blue-600/25 dark:ring-blue-500/40",
      foreground: "text-primary dark:text-blue-200",
      hover: "hover:bg-primary/20 dark:hover:bg-primary/25",
      icon: "text-primary dark:text-blue-300",
    },
    // Premium: Black Luxury (Canon v1.4.5)
    premium: {
      surface: "bg-slate-900 dark:bg-slate-950",
      border: "ring-1 ring-slate-700 dark:ring-slate-600",
      foreground: "text-white",
      hover: "hover:bg-slate-800 dark:hover:bg-slate-900",
      icon: "text-slate-300 dark:text-slate-400",
    },
    // Zen: Cloud Dancer (Pantone 2026, Canon v1.4.5)
    zen: {
      surface: "bg-[#F0EFEA] dark:bg-slate-900",
      border: "ring-1 ring-[#E5E4DF] dark:ring-slate-700",
      foreground: "text-[#0D1F1A] dark:text-slate-100",
      hover: "hover:bg-[#F8F7F4] dark:hover:bg-slate-800",
      icon: "text-[#132B24] dark:text-slate-300",
    },
  },
};

export type StatusColorKey = keyof typeof colors.status;
